import Buffer from './Buffer';

export default class VertexBuffer extends Buffer {

	constructor(gl, attributeName, itemSize, dynamic) {
		super(gl, gl.ARRAY_BUFFER, attributeName, itemSize, dynamic, [Float32Array]);
	}

	bind(program) {
		const gl = this._gl;
		const attributeHandle = program.getAttributeLocation(this._attributeName);
		gl.bindBuffer(this._type, this._object);
		gl.vertexAttribPointer(
			attributeHandle,
			this._itemSize,
			gl.FLOAT,
			gl.FALSE /* normalised */,
			0 /* stride */,
			0 /* byte offset */);
		gl.enableVertexAttribArray(attributeHandle);
	}

	draw(program, primitiveType, itemCount = -1, itemStart = 0) {
		if (itemCount === -1) {
			itemCount = this.getItemCount();
		}
		const gl = this._gl;
		this.bind(program);
		gl.drawArrays(primitiveType, itemStart, itemCount);
	}

}
